export default __webpack_public_path__ + "static/initial-light-12a03a8ae0c03dd01f6e204a843ab41e.png";